
import { SetStorage } from "../../../Utils/Storage";

import { utcToLocalTime } from "../../../Utils/formant";
import { Notification } from "../../../Utils/Notification";
import i18n from "../../../i18n";

export const Dialogs = (state, action) => {
  const newState = {
    ...state,
    dialogsFlag: {
      ...state.dialogsFlag,
      [action.key]:
        action.value
    }
  }

  return newState
};

export const clearState = (state, action, initial) => {
  return {
    ...state,
    [action.state]: initial[action.state]
  }
};



export const getOrganization = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
    response: state.Organizations.response
  };
  return { ...state, Organizations: updateValue };
};
export const getOrganizationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, Organizations: updateValue };
};
export const getOrganizationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Organizations: updateValue };
};



export const addOrg = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddOrg: updateValue };
};
export const addOrgSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(i18n.t("Notification.AddOrg"), "success");

  return { ...state, AddOrg: updateValue };
};
export const addOrgFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddOrg: updateValue };
};



export const editOrg = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, EditOrg: updateValue };
};
export const editOrgSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, EditOrg: updateValue };
};
export const editOrgFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, EditOrg: updateValue };
};



export const editTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AditTenant: updateValue };
};
export const editTenantSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, AditTenant: updateValue };
};
export const editTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AditTenant: updateValue };
};



export const addTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AddTenant: updateValue };
};
export const addTenantSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, AddTenant: updateValue };
};
export const addTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddTenant: updateValue };
};



export const getOrgById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.Organization.response,
    error: null,
  };
  return { ...state, Organization: updateValue };
};
export const getOrgByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, Organization: updateValue };
};
export const getOrgByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Organization: updateValue };
};



export const getAllTenants = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.Tenants.response,
    error: null,
  };
  return { ...state, Tenants: updateValue };
};
export const getAllTenantsSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, Tenants: updateValue };
};
export const getAllTenantsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Tenants: updateValue };
};



export const changeOrgActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgActivation: updateValue };
};
export const changeOrgActivationSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, OrgActivation: updateValue };
};
export const changeOrgActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrgActivation: updateValue };
};





export const changeTenantActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantActivation: updateValue };
};
export const changeTenantActivationSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, TenantActivation: updateValue };
};
export const changeTenantActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantActivation: updateValue };
};




export const deleteTenant = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeleteTenant: updateValue };
};
export const deleteTenantSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, DeleteTenant: updateValue };
};
export const deleteTenantFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DeleteTenant: updateValue };
};




export const getOrganizationUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrganizationUser: updateValue };
};
export const getOrganizationUserSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, OrganizationUser: updateValue };
};
export const getOrganizationUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrganizationUser: updateValue };
};




export const comparePolygons = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ComparePolygon: updateValue };
};
export const comparePolygonsSuccess = (state, action) => {

  if (action.res.data?.entity?.length) {
    var data = action.res.data?.entity.map(item => {
      return {
        name: item.planName,
        Optime_Polygons: item.initialPolygons || 0,
        Current_Polygons: item.currentPolygons || 0
      }
    })
  }
  const updateValue = {
    request: null,
    response: data,
    error: null,
  };
  return { ...state, ComparePolygon: updateValue };
};
export const comparePolygonsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, ComparePolygon: updateValue };
};




export const getTenantUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantUser: updateValue };
};
export const getTenantUserSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, TenantUser: updateValue };
};
export const getTenantUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantUser: updateValue };
};




export const getTenantById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, Tenant: updateValue };
};
export const getTenantByIdSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, Tenant: updateValue };
};
export const getTenantByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, Tenant: updateValue };
};




export const updateTenantUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdateTenantUser: updateValue };
};
export const updateTenantUserSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, TeUpdateTenantUsernant: updateValue };
};
export const updateTenantUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdateTenantUser: updateValue };
};




export const updateOrgUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdateOrgUser: updateValue };
};
export const updateOrgUserSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, UpdateOrgUser: updateValue };
};
export const updateOrgUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdateOrgUser: updateValue };
};



export const changeTenantPassword = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, TenantPassword: updateValue };
};
export const changeTenantPasswordSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res.data?.messageFa : action.res.data?.message, 'success')
  return { ...state, TenantPassword: updateValue };
};
export const changeTenantPasswordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, TenantPassword: updateValue };
};




export const downloadUsage = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, DownloadUsage: updateValue };
};
export const downloadUsageSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };
  return { ...state, DownloadUsage: updateValue };
};
export const downloadUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, DownloadUsage: updateValue };
};



export const getUserToken = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OtherUserToken: updateValue };
};
export const getUserTokenSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.data?.token,
    error: null,
  };
  SetStorage("check_user_tenant_token", action.res.data?.token, "local")
  return { ...state, OtherUserToken: updateValue };
};
export const getUserTokenFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OtherUserToken: updateValue };
};



export const getOrganizationUsage = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgUsage: updateValue };
};
export const getOrganizationUsageSuccess = (state, action) => {
  const chartData = [];
  action.res.data?.entity.forEach(item => {
    const obj = {}
    item.usageDetailList = item.usageDetailList.sort((a, b) => {
      if (a.amount > b.amount) {
        return -1;
      }
      if (a.amount === b.amount) {
        return 0;
      }
      return 1;
    });
    obj.name = utcToLocalTime(item.creationTime, action.interval === "DAILY" ? "jYYYY/jM/jD" : action.interval === "MONTHLY" ? "jYYYY/jM" : "HH:mm:ss");
    item?.usageDetailList?.forEach(tenant => {
      obj[tenant.tenantName] = tenant.amount;
    })
    let total = 0;
    Object.keys(obj).forEach(key => {
      if (key !== "name") {
        total = total + obj[key];
      }
    })
    obj.Total = total
    chartData.push(obj)
  });

  const TenantNamesList = action.res.data?.entity[0].usageDetailList.map(item => item.tenantName)

  const updateValue = {
    request: null,
    response: chartData,
    error: null,
    tenantsList: TenantNamesList,
  };

  return { ...state, OrgUsage: updateValue };
};
export const getOrganizationUsageFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, OrgUsage: updateValue };
};



export const addOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: state.AddOrgPOC.response,
    error: null,
  };
  return { ...state, AddOrgPOC: updateValue };
};
export const addOrgPOCSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, AddOrgPOC: updateValue };
};
export const addOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddOrgPOC: updateValue };
};


export const removeOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RemoveOrgPOC: updateValue };
};
export const removeOrgPOCSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: true,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res.data?.messageFa : action.res.data?.message, "success")
  return { ...state, RemoveOrgPOC: updateValue };
};
export const removeOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, RemoveOrgPOC: updateValue };
};


export const deliveryReport = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeliveryReport: updateValue };
};
export const deliveryReportSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res?.data,
    error: null,
  };
  return { ...state, DeliveryReport: updateValue };
};
export const deliveryReportFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, DeliveryReport: updateValue };
};


export const getOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgPOC: updateValue };
};
export const getOrgPOCSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, OrgPOC: updateValue };
};
export const getOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, OrgPOC: updateValue };
};




export const updateOrgPOC = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, UpdatePOC: updateValue };
};
export const updateOrgPOCSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, UpdatePOC: updateValue };
};
export const updateOrgPOCFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdatePOC: updateValue };
};
